// Meeting Points data for German cities
// This data is automatically loaded and displayed on the map

export interface MeetingPoint {
  id: string;
  name: string;
  address: string;
  metropolitanRegion: string;
  // Pre-geocoded coordinates to avoid API calls on every load
  // Format: [longitude, latitude]
  coordinates: [number, number];
  region?: string;
  regionId?: string;
}

export const meetingPointsData: Omit<MeetingPoint, 'region' | 'regionId'>[] = [
  {
    id: 'meeting-berlin',
    name: 'Berlin',
    address: 'Rudower Chaussee 29, 12489 Berlin, Deutschland',
    metropolitanRegion: 'Berlin-Brandenburg',
    coordinates: [13.5024, 52.4255], // [longitude, latitude]
  },
  {
    id: 'meeting-frankfurt',
    name: 'Frankfurt',
    address: 'Baseler Straße 48, 60329 Frankfurt am Main, Deutschland',
    metropolitanRegion: 'Frankfurt Rhein-Main',
    coordinates: [8.6821, 50.1109],
  },
  {
    id: 'meeting-hamburg',
    name: 'Hamburg',
    address: 'Zirkusweg 1, 20359 Hamburg, Deutschland',
    metropolitanRegion: 'Hamburg',
    coordinates: [9.9937, 53.5511],
  },
  {
    id: 'meeting-hannover',
    name: 'Hannover',
    address: 'Bödekerstraße 1, 30161 Hannover, Deutschland',
    metropolitanRegion: 'Hannover',
    coordinates: [9.7320, 52.3759],
  },
  {
    id: 'meeting-munchen',
    name: 'München',
    address: 'Landsberger Straße 314, 80687 München, Deutschland',
    metropolitanRegion: 'München',
    coordinates: [11.5320, 48.1351],
  },
  {
    id: 'meeting-neuss',
    name: 'Neuss',
    address: 'Hellersbergstraße 12, 41460 Neuss, Deutschland',
    metropolitanRegion: 'Rheinland',
    coordinates: [6.6850, 51.2042],
  },
  {
    id: 'meeting-mannheim',
    name: 'Mannheim',
    address: 'P7 20, 68161 Mannheim, Deutschland',
    metropolitanRegion: 'Rhein-Neckar',
    coordinates: [8.4660, 49.4875],
  },
  {
    id: 'meeting-dortmund',
    name: 'Dortmund',
    address: 'Hansaplatz 30, 44137 Dortmund, Deutschland',
    metropolitanRegion: 'Ruhrgebiet',
    coordinates: [7.4653, 51.5136],
  },
  {
    id: 'meeting-bochum',
    name: 'Bochum',
    address: 'Südring 25, 44787 Bochum, Deutschland',
    metropolitanRegion: 'Ruhrgebiet',
    coordinates: [7.2162, 51.4818],
  },
  {
    id: 'meeting-essen',
    name: 'Essen',
    address: 'Lindenallee 41, 45127 Essen, Deutschland',
    metropolitanRegion: 'Ruhrgebiet',
    coordinates: [7.0123, 51.4556],
  },
  {
    id: 'meeting-duisburg',
    name: 'Duisburg',
    address: 'Kohleninsel 5, 47138 Duisburg, Deutschland',
    metropolitanRegion: 'Ruhrgebiet',
    coordinates: [6.7651, 51.4344],
  },
  {
    id: 'meeting-stuttgart',
    name: 'Stuttgart',
    address: 'Maybachstraße 20, 70469 Stuttgart, Deutschland',
    metropolitanRegion: 'Stuttgart',
    coordinates: [9.1815, 48.7758],
  },
];

